import { Injectable } from '@angular/core';
import { BehaviorSubject ,  Observable } from 'rxjs';
import { SubHeader } from '../models/sub-header.model';

@Injectable()
export class SubHeaderService {
    public subHeader = new BehaviorSubject<any>(new SubHeader({ title: undefined }));

    updateSubHeader(data): void {
        this.subHeader.next(data);
    }

    onSubHeaderChange(): Observable<any> {
        return this.subHeader.asObservable();
    }

    getSubHeader(): SubHeader {
        return this.subHeader.value;
    }
}